import { useSelector } from 'react-redux';

import { areUserRolesIn } from '../../helpers';
import { Roles } from '../../constants';

import type { RootState } from '../../store';

// Whether the current user may invite a pre-clinical parent to the platform. Inviting is
// limited to admins and onboarding coordinators.
export const useCanInviteProviderToPlatform = (): boolean => {
  const { user } = useSelector((state: RootState) => state.auth);

  return areUserRolesIn(user?.roles, [Roles.Admin, Roles.OnboardingCoordinator]);
};
